import { ArrowUpRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import type { SearchResult } from '@/types/search';
import { formatRelativeTime } from '@/utils/date';

type SearchResultCardProps = {
  result: SearchResult;
};

export function SearchResultCard({ result }: SearchResultCardProps) {
  const { article, matchedFields } = result;

  return (
    <Link
      to={`/noticia/${article.slug}`}
      className="grid grid-cols-[92px_1fr] gap-3 rounded bg-divergent-panel p-3 transition hover:bg-white/10"
    >
      <img src={article.hero.url} alt={article.hero.alt} className="h-28 w-full rounded object-cover" loading="lazy" />
      <div className="min-w-0">
        <div className="flex items-center justify-between gap-2">
          <span className="text-xs font-semibold uppercase tracking-[0.12em] text-divergent-yellow">
            {article.category}
          </span>
          <ArrowUpRight size={17} aria-hidden="true" className="shrink-0 text-white/45" />
        </div>
        <h2 className="mt-1 line-clamp-2 text-base font-bold leading-tight">{article.title}</h2>
        <p className="mt-1 line-clamp-2 text-sm leading-5 text-white/62">{article.summary}</p>
        <div className="mt-2 flex flex-wrap gap-2 text-[11px] text-white/42">
          <span>{formatRelativeTime(article.publishedAt)}</span>
          {matchedFields.slice(0, 2).map((field) => (
            <span key={field}>#{field}</span>
          ))}
        </div>
      </div>
    </Link>
  );
}
